import { queryKeys } from "@/common/constants/query.constants";
import { apiRoutes } from "@/common/config/configuration";
import { useApiMutationHook } from "@/common/hooks/use-generic-api";
import { ApiRequestMethod } from "../config/api-handler";
import { serviceType } from "@/common/constants/serviceType.constants";
import {
  UserLogoutRequest,
  UserLogoutResponse,
} from "../types/authentication.types";

export const useUserLogoutMutation = () =>
  useApiMutationHook<UserLogoutRequest, UserLogoutResponse>(
    queryKeys.authentication.logout,
    `${apiRoutes.organizationManagementService.baseUrl}${apiRoutes.organizationManagementService.authentication.logoutServiceUrl}`,
    ApiRequestMethod.POST,
    serviceType.authentication.logout,
  );
